import { DriveDeckTransportClient } from '../transport/client';

export class InputCaptureEngine {
  private canvas: HTMLCanvasElement;
  private client: DriveDeckTransportClient;
  private activePointer: number | null = null;

  constructor(canvas: HTMLCanvasElement, client: DriveDeckTransportClient) {
    this.canvas = canvas;
    this.client = client;
    this.setupListeners();
  }

  private setupListeners() {
    this.canvas.addEventListener('pointerdown', (e) => this.handlePointer(e, 0));
    this.canvas.addEventListener('pointermove', (e) => this.handlePointer(e, 1));
    this.canvas.addEventListener('pointerup', (e) => this.handlePointer(e, 2));
    this.canvas.addEventListener('pointercancel', (e) => this.handlePointer(e, 3));

    // Prevent default touch behaviors (pinch to zoom, pull to refresh)
    this.canvas.addEventListener('contextmenu', (e) => e.preventDefault());
  }

  private handlePointer(e: PointerEvent, action: number) {
    if (action === 1 && e.buttons === 0) {
      // Ignore hover move without active press
      return;
    }

    if (action === 0) {
      if (this.activePointer !== null) return;
      this.activePointer = e.pointerId;
      this.canvas.setPointerCapture(e.pointerId);
    } else if (this.activePointer !== e.pointerId) return;
    e.preventDefault();
    if (action === 2 || action === 3) {
      this.activePointer = null;
      if (this.canvas.hasPointerCapture(e.pointerId)) this.canvas.releasePointerCapture(e.pointerId);
    }

    const rect = this.canvas.getBoundingClientRect();
    if (rect.width === 0 || rect.height === 0) return;

    const normalizedX = Math.max(0, Math.min(1, (e.clientX - rect.left) / rect.width));
    const normalizedY = Math.max(0, Math.min(1, (e.clientY - rect.top) / rect.height));

    this.client.sendInput({
      action,
      normalizedX,
      normalizedY,
      pointerId: e.pointerId,
    });
  }
}
